import styled from 'styled-components/native'

export const InlineView = styled.View`
    display: inline;
`

export const StyledText = styled.Text<{ fontcolor: string, textDecoration: boolean}>`
  color: ${({ fontcolor }) => fontcolor};
  text-decoration: ${({ textDecoration }) => (!textDecoration || 'line-through')};
`